import { AutoComplete,  Button,  DatePicker,  Form, Space, Tree } from "antd"
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { useThrottleEffect } from "ahooks";
import { Partner } from "../../../../constants/partners";
import { DataNode } from "antd/lib/tree";
import dayjs from "dayjs";
import { Page } from "../../../../constants/common";
import Request from "../../../../requestor";

interface CommonParams {
  registerReset: (resetFun: () => void) => void
};

let options_provider = [
  { value: '人保' },
  { value: '平安' },
  { value: '鼎和' },
];

let options_driverCompany = [
  { value: '拖车侠' },
  { value: '修理厂' },
];


let _Pa = /[`~!#$%^&*()_\+=<>?:"{}|~！#￥%……&*（）={}|《》？：“”【】、；'‘’，。、\s+]/g


const Auto = ({ options, onChange }: { options?: { value: string }[], onChange: (v: string) => void }) => {
  return <AutoComplete
    style={{ width: 200 }}
    options={options}
    placeholder="请输入或者选择搜索"
    filterOption={(inputValue, option) =>
      option!.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
    }
    onChange={onChange}
  />
}

export const SearchFormItemTags = ({ name, onChange }: { name: string, onChange: (v: DataNode[]) => void }) => {
  const [partners, setPartners] = useState<Partner[]>([]);
  const [value, setValue] = useState<string>('');
  // const requestor = useSelector(getRequestor)


  const pagePartners = useCallback(
    async (value: string = "") => {
      let page = 1;
      let size = 12;
      let where: string = encodeURIComponent(`(\`name\` like '%${value.trim()}%' or \`alias\` like '%${value.trim()}%')`);

      try {
        const res = await Request.pagePartners<Page<Partner>>(page, size, where);
        if (res.error !== "") {
          throw new Error(res.error);
        }
        if (res.result) {
          setPartners(res.result.payload)
        }
      } catch (e) {
      }
    },
    []
  );

  useThrottleEffect(
    () => {
      if (value) {
        pagePartners(value)
      }
    },
    [value],
    {
      wait: 800,
    },
  );

  useEffect(() => {
    let options = partners.map(d => ({
      title: d.name.replace("中国人民财产保险股份有限公司", "人保")
        .replace("中国平安财产保险股份有限公司", "平安"),
      key: d.id
    }))
    onChange(options)
  }, [partners])

  let autoOptions = useMemo(() => {
    return name === 'driverCompany' ? options_driverCompany : options_provider
  }, [name])

  return <Form.Item name="autoName" style={{ marginBottom: '0px' }}>
    <Auto options={autoOptions} onChange={(v) => { setValue(v); }} />
  </Form.Item>
}

// ** 报案号搜索 **
interface TextProps extends CommonParams {
  label: string
  skey?: string//用于缓存数据的key，不传不缓存
  onChange: (value: string[]) => void,
}

const _LIS_STORAGE_KEY = "_lis_save_storage__"
export const TextFilter = ({ skey, label, registerReset, onChange }: TextProps) => {
  const [options, setOptions] = useState<{ value: string }[]>([])
  const [form] = Form.useForm()
  let AutoCompleteOptions = useRef<string[]>([])

  const onReset = useCallback(() => {
    form.resetFields();
  }, [])

  useEffect(() => {
    if (!skey) return;
    let optstr = localStorage.getItem(_LIS_STORAGE_KEY + skey)
    if (!optstr) return;

    try {
      let strs: string[] = JSON.parse(optstr);
      setOptions(strs.map(s => ({ value: s })))
    } catch (error) {

    }

  }, [skey])

  // 进行缓存处理
  const setStorage = useCallback((key: string, value: string) => {
    let oidx = AutoCompleteOptions.current.indexOf(value)
    if (oidx > -1) {
      AutoCompleteOptions.current.splice(oidx, 1);
      AutoCompleteOptions.current.unshift(value)
    } else {
      AutoCompleteOptions.current.unshift(value)
    }

    if (AutoCompleteOptions.current.length > 6) {
      AutoCompleteOptions.current.pop()
    }

    localStorage.setItem(_LIS_STORAGE_KEY + key, JSON.stringify(AutoCompleteOptions.current))
    setOptions(AutoCompleteOptions.current.map(s => ({ value: s })))
  }, [])

  useEffect(() => {
    registerReset(onReset)
  }, [registerReset])

  return <Form style={{ padding: "10px" }} form={form} onFinish={() => {
    let value = form.getFieldValue('value');
    value = value.trim();
    onChange([value]);
    if (skey && value !== "") { setStorage(skey, value) }
  }}>
    <Form.Item name="value">
      <AutoComplete
        style={{ width: 200 }}
        options={options}
        placeholder={"请输入或者选择搜索" + label}
        filterOption={(inputValue, option) =>
          option!.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
        }
      />
    </Form.Item>
    <Form.Item style={{ marginBottom: "4px" }}>
      <Space style={{ float: "right" }}>
        <Button htmlType="reset" onClick={() => { onChange([]) }}>重置</Button>
        <Button type="primary" htmlType="submit">筛选</Button>
      </Space>
    </Form.Item>
  </Form>
};

// ** 状态类--车型大小搜索 **
interface SearchFormItemPropsType extends CommonParams {
  noFormwrapper?: boolean
  multiple: boolean
  totalselectkey?: string | number
  treeData: DataNode[],
  onChange: (value: (string | number)[]) => void,
}

// 标记全选的key值
let DefaultTotalSelectKey: string | number = -1;

export const StatusFilterTree = ({ noFormwrapper, treeData, onChange, multiple, totalselectkey, registerReset }: SearchFormItemPropsType) => {
  const [selectedKeys, setselectedKeys] = useState<(string | number)[]>([])
  const [options, setOptions] = useState<DataNode[]>(treeData)
  const selectOptions = useRef<DataNode[]>([])

  const totalSelectKey = useMemo(() => { return totalselectkey === undefined ? DefaultTotalSelectKey : totalselectkey }, [totalselectkey])

  const setkeys = useCallback((keys: (string | number)[], targetkey?: string | number) => {
    if (targetkey === totalSelectKey) {
      if (keys.includes(totalSelectKey)) {
        setselectedKeys(treeData.map(item => item.key));
        selectOptions.current = [...treeData]
      } else {
        setselectedKeys([])
        selectOptions.current = []
      }
    } else {
      // 非全选状态下，取消全选框的选中状态
      if (keys.includes(totalSelectKey) && keys.length < treeData.length) {
        let skeys = keys.filter(item => item !== totalSelectKey)
        setselectedKeys(skeys);
        selectOptions.current = treeData.filter(item => (skeys.includes(item.key)))
      } else {
        setselectedKeys(keys);
        selectOptions.current = treeData.filter(item => (keys.includes(item.key)))
      }
    }
  }, [treeData, totalSelectKey])

  useEffect(() => {
    if (selectOptions.current.length > 0) {
      let selects = selectOptions.current.map(item => item.key)
      let newOpts = treeData.filter(t => !selects.includes(t.key))
      let newItem = [...selectOptions.current, ...newOpts]
      setOptions(newItem)
    } else {
      setOptions([...treeData])
    }
  }, [treeData])

  // 重置 不会触发onChange
  const reset = useCallback(() => {
    setkeys([])
  }, [setkeys])

  useEffect(() => {
    registerReset(reset)
  }, [registerReset,])

  const Items = () => {
    return <>
      <Form.Item className="clearfix" name="status" style={{ marginBottom: "8px" }}>
        <Tree
          className="clearfix"
          // style={{ maxHeight: "100px", overflow: "auto" }}
          multiple={multiple}
          checkable
          checkedKeys={selectedKeys}
          selectedKeys={selectedKeys}
          onSelect={(selectedKeys, info) => {  setkeys(selectedKeys, info.node.key); }}
          onCheck={(keys, info) => {
            // 兼容选框的单选
            if (multiple === false) {
              let node = info.node
              if (node.checked) {
                setkeys([], info.node.key);
              } else {
                setkeys([node.key], info.node.key);
              }
            } else {
              setkeys(keys as number[], info.node.key);
            }
          }}
          treeData={options}
        />
      </Form.Item>
      <Form.Item style={{ padding: "0px 10px 10px 10px" }}>
        <Space size={50}>
          <Button type="default" onClick={() => { setkeys([]); onChange([]) }}>重置</Button>
          <Button type="primary" onClick={() => {
            // 选择全部的情况下，等同于不选，所以筛选条件是空
            if (selectedKeys.includes(totalSelectKey)) {
              onChange([])
            } else {
              onChange(selectedKeys)
            }
          }}>筛选</Button>
        </Space>
      </Form.Item></>
  }

  return <div className="padding-top-16px clearfix" style={{ width: "200px" }}>
    {
      noFormwrapper ? <Items /> : <Form className="clearfix" layout="horizontal" wrapperCol={{ md: 24 }}>
        <Items />
      </Form>
    }

  </div>
};

// ** 时间筛选 ** 
interface TimerProps extends CommonParams {
  onChange: (value: [dayjs.Dayjs, dayjs.Dayjs] | []) => void,
}

export const TimerFilter = ({ onChange, registerReset }: TimerProps) => {

  const [form] = Form.useForm()

  const reset = () => form.resetFields()

  useEffect(() => {
    registerReset(reset)
  }, [registerReset,])

  return <div style={{ padding: "16px 10px 1px" }} ><Form form={form} onFinish={() => { let time = form.getFieldValue('time'); onChange(time) }}>
    <Form.Item name="time">
      <DatePicker.RangePicker
        style={{ width: "100%" }}
        ranges={{
          上月: [
            dayjs()
              .startOf("month")
              .subtract(1, "day")
              .startOf("month"),
            dayjs()
              .startOf("month")
              .subtract(1, "month")
              .endOf("month"),
          ],
          本月: [dayjs().startOf("month"), dayjs()],
          本周: [dayjs().startOf("week"), dayjs()],
          昨天: [
            dayjs().startOf("day").subtract(1, "day").startOf("day"),
            dayjs().startOf("day").subtract(1, "second"),
          ],
          今天: [dayjs().startOf("day"), dayjs()],
        }} />
    </Form.Item>
    <Form.Item style={{ width: "100%", paddingRight: "16px" }}>
      <Space size={50} style={{ float: "right" }}>
        <Button type="default" onClick={() => { reset(); onChange([]) }}>重置</Button>
        <Button type="primary" htmlType="submit">筛选</Button>
      </Space>
    </Form.Item>
  </Form></div>
};




